export const METRIKA_ID = 108166819;
const PUBLIC_PAGES = new Set(['/', '/records', '/news', '/predictions', '/calendar', '/support']);

export function metrikaPageUrl(value) {
  const url = new URL(value);
  if (url.protocol !== 'https:' || !['ovi-stats.ru', 'www.ovi-stats.ru'].includes(url.hostname)) return null;
  if (!PUBLIC_PAGES.has(url.pathname) && !/^\/records\/\d+$/.test(url.pathname) && !/^\/news\/[a-z0-9-]+$/.test(url.pathname)) return null;
  // Search typing and anchor scrolling do not create additional pageviews.
  url.searchParams.delete('q');
  url.searchParams.delete('_ym_debug');
  url.searchParams.delete('_ym_status-check');
  url.hash = '';
  return url.href;
}

export function createMetrikaTracker(browser, document) {
  let initialized = false;
  let lastPage = null;
  let referrer = document.referrer;
  if (referrer) {
    try {
      const previous = new URL(referrer);
      if (['ovi-stats.ru', 'www.ovi-stats.ru'].includes(previous.hostname)) referrer = metrikaPageUrl(referrer) || '';
    } catch { referrer = ''; }
  }

  function stop() {
    if (initialized) browser.ym(METRIKA_ID, 'destruct');
    initialized = false;
    lastPage = null;
    // Do not send a private editor URL as the referrer when returning to the site.
    referrer = '';
  }

  return {
    visit(value, title) {
      const page = metrikaPageUrl(value);
      if (!page) { stop(); return; }
      if (lastPage === page) return;
      if (!initialized) {
        if (!browser.ym) {
          browser.ym = function () { (browser.ym.a = browser.ym.a || []).push(arguments); };
          browser.ym.l = Date.now();
        }
        const src = `https://mc.yandex.ru/metrika/tag.js?id=${METRIKA_ID}`;
        if (![...document.scripts].some((script) => script.src === src)) {
          const script = document.createElement('script');
          script.async = true;
          script.src = src;
          document.head.append(script);
        }
        browser.ym(METRIKA_ID, 'init', {
          ssr: true,
          defer: true,
          webvisor: true,
          clickmap: true,
          trackLinks: true,
          accurateTrackBounce: true,
          ecommerce: 'dataLayer',
          url: page,
          referrer,
        });
        initialized = true;
      }
      browser.ym(METRIKA_ID, 'hit', page, { title, referer: lastPage || referrer });
      lastPage = page;
    },
  };
}
